import { useIsStaff, useIsSuperAdmin } from './hooks/useRole';
import { StaffLayout } from './layouts/StaffLayout';
import { AgentLayout } from './layouts/AgentLayout';
import { RootLayout } from './layouts/RootLayout';

/**
 * RoleRouter — reads the JWT role and returns the correct layout shell.
 * Superadmin → RootLayout (includes Root nav section)
 * Staff (staff | admin) → StaffLayout
 * Agent → AgentLayout
 *
 * This component is used as the `element` for the authenticated route group
 * in App.tsx. All existing routes remain unchanged — only the wrapping shell
 * differs based on role.
 *
 * ⚠️ PUBLIC ROUTES — must NEVER appear inside RoleRouter or ProtectedRoute:
 *   /start, /start/path, /start/staff/step/:step, /start/self,
 *   /start/summary, /start/payment, /start/confirmation
 *
 * These are declared as top-level public routes in App.tsx. Do not move them
 * into the authenticated route group below.
 */
export function RoleRouter() {
  const isSuperAdmin = useIsSuperAdmin();
  const isStaff = useIsStaff();
  if (isSuperAdmin) return <RootLayout />;
  return isStaff ? <StaffLayout /> : <AgentLayout />;
}
